import React from 'react';
import { Button } from './ui/button';
import { accessories } from '../data/mock';
import { EMS_STATUS, DISPATCH_NOTE, ACCESSORY_DELIVERY_NOTE } from '../data/availability';
import { startCheckout, hasLink } from '../lib/checkout';
import ProductGallery from './ProductGallery';
import { toast } from 'sonner';

const Accessories = () => {
  const handleCheckout = (item) => {
    try {
      const route = startCheckout(item, 'accessory');
      if (route === 'enquiry') {
        toast.success('Opening WhatsApp so we can confirm your order and delivery.');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      toast.error('Something went wrong. Please contact us and we will take the order directly.');
    }
  };

  return (
    <section id="accessories" className="py-20 bg-slate-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-cyan-400 neon-text uppercase tracking-wider" data-testid="accessories-title">
            Accessories
          </h2>
          <p className="mt-3 text-sm text-cyan-400 font-semibold">
            {EMS_STATUS} &middot; {DISPATCH_NOTE}
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {accessories.map((item) => (
            <div
              key={item.id}
              className="glass-card rounded-xl overflow-hidden border border-slate-700 hover:border-cyan-500/50 transition-all duration-300"
              data-testid={`accessory-card-${item.id}`}
            >
              <ProductGallery item={item} className="h-48" />

              <div className="p-5 space-y-4">
                <div className="text-center">
                  <h3 className="text-lg font-semibold text-white">
                    {item.name}
                  </h3>
                  <p className="text-gray-500 text-xs mt-1">{item.subtitle}</p>
                  <p className="text-gray-600 text-[11px] mt-2">1 year warranty &middot; {DISPATCH_NOTE}</p>
                </div>

                <Button
                  className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-bold rounded-full py-4"
                  onClick={() => handleCheckout(item)}
                  data-testid={`accessory-buy-btn-${item.id}`}
                >
                  <div className="flex flex-col items-center">
                    <span className="text-xs">
                      {hasLink('accessory', item.id) ? 'Buy now' : 'Enquire to order'}
                    </span>
                    <span className="text-base font-black">{item.price}</span>
                  </div>
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-cyan-400 font-semibold">
            {ACCESSORY_DELIVERY_NOTE}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Accessories;
